import React, { Component } from 'react'
import { Link } from 'react-router'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage, isVoca } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

import PkReward from './pkReward/index'
import RankThisWeek from './RankThisWeek'
import RankLastWeek from './RankLastWeek'
import RoomLastWeek from './RoomLastWeek'
import RoomThisWeek from './RoomThisWeek'
import RuleReminder from './RuleReminder'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.pkStore = this.props.store.register('activity/pk')
    this.state = {
      tabShow: '0',
      lang: langM.ar,
      showRule: false,
      ruleOrHis: '0',
      language:'en',
    }
  }
  componentDidMount() {
    setDocumentTitle('PK')
    this.$logEvent("pk_main_screen")
  }
  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    // 身份验证请求数据
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }
  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    this.pkStore.GetUserInfoWeb(uid)
    this.pkStore.GetKingRank()
    this.pkStore.GetRoomRank()
    this.pkStore.GetSupporterRank()
    this.pkStore.pkCountDown()
    this.pkStore.hitoryTop()
  }

  // 调节位置
  leftData() {
    if (this.state.tabShow == '0') {
      return '0'
    } else if (this.state.tabShow == '1') {
      return '30%'
    } else {
      return '60%'
    }
  }
  // 切换tab栏
  changeNav(val) {
    if (val == 0) {
      this.$logEvent("pk_king")
      console.log(0)
    }
    if (val == 1) {
      this.$logEvent("pk_booster")
      console.log(1)
    }
    if (val == 2) {
      this.$logEvent("pk_room")
      console.log(2)
    }
    this.setState({
      tabShow: val
    })
  }
  // 切换rule
  changeRule(val) {
    if (val.state == 0) {
      this.$logEvent("pk_rule")
    }
    if (val.state == 1) {
      this.$logEvent("pk_ honor")
    }
    this.setState({
      showRule: (this.state.showRule = val.state),
      ruleOrHis: val.value
    })
  }

  render() {
    let { language, lang } = this.state
    let {
      userInfo,
      lastKingRank,
      thisKingRank,
      lastRoomRank,
      thisRoomRank,
      lastSupporterRank,
      thisSupporterRank,
      remaintime,
      lastKingMyRank,
      thisKingMyRank,
      thisRoomMyRank,
      thisSupporterMyRank,
      lastSupporterMyRank,
      historyList
    } = this.pkStore.data
    // pk
    let pkTopGifts = [
      {
        title: {
          en: 'NO1',
          tr: 'İlk 1',
          ar: 'NO1',
          id: 'NO1',
          pt: 'NO1',
          ru: 'Топ-1',
          uz: 'Top-1',
          fa: 'اولین',
          ur: 'اولین',
          th: 'ที่ 1'
        },
        list: [
          {
            name: {
              en: 'Medal * 7days<br/>(score>500K)',
              tr: 'Madalya (7Gün)<br/>(500K Üstü)',
              ar: 'Medal * 7days<br/>(score>500K)',
              ru: 'Медаль * 7 дней<br/>(счёт > 500K)',
              id: 'Medali * 7 hari<br/>(skor>500K)',
              pt: 'Medalha * 7 dias<br/>(pontuação>500K)',
              uz: 'Medal * 7 kun<br/>(ball>500K)',
              fa: 'مدال * 7 روز<br/>(امتیاز > 500K)',
              ur: 'میڈل * 7 دن<br/>(اسکور>500K)',
              th: 'เหรียญ * 7 วัน<br/>(คะแนน>500K)'
            },
            desc: 'won',
            img: '/img/activity/pk/pp_xz1.png',
            id: Math.random()
          }
        ],
        list2: [
          {
            name: {
              en: 'Banner * 7days',
              tr: 'Banner (7Gün)',
              ar: 'Banner * 7days',
              ru: 'Баннер * 7 дней',
              id: 'Spanduk * 7 hari',
              pt: 'Banner * 7 dias',
              uz: 'Banner * 7 kun',
              fa: 'بنر * 7 روز',
              ur: 'بنر * 7 دن',
              th: 'แบรนด์ * 7 วัน'
            },
            img: '/img/activity/pk/banner.png',
            id: Math.random()
          },
          {
            name: {
              en: 'Duke * 7days',
              tr: 'Vip 4 (7Gün)',
              ar: 'Duke * 7days',
              ru: 'Герцог * 7 дней',
              id: 'Mengambil * 7 hari',
              pt: 'Levando * 7 dias',
              uz: '7 kun davom etadi',
              fa: 'مصرف * ۷ روز',
              ur: '* 7 دن لے رہے ہیں۔',
              th: 'ใช้เวลา * 7 วัน'
            },
            img: 'https://img.chatie.live/app/noble/vipicon/vip_lv4.png',
            id: Math.random()
          },
          {
            name: {
              en: 'Headwear * 7days',
              tr: 'Çerçeve (7Gün)',
              ar: 'Headwear * 7days',
              ru: 'Головной убор * 7 дней',
              th: 'หมวก * 7 วัน',
              ur: 'ہیڈویئر * 7 دن',
              fa: 'سرپوش * ۷ روز',
              id: 'Penutup Kepala * 7 hari',
              pt: 'Chapéus * 7 dias',
              uz: 'Bosh kiyimlar * 7 kun'
            },
            img: '/img/activity/pk/p_t1.png',
            id: Math.random()
          }
        ],
        list3: [
          {
            name: {
              en: 'Mount * 7days',
              tr: 'Araç (7Gün)',
              ar: 'Mount * 7days',
              ru: 'Транспорт * 7 дней',
              id: 'Kendaraan * 7 hari',
              pt: 'Veículo * 7 dias',
              uz: 'Transport * 7 kun',
              fa: 'موتور * ۷ روز',
              ur: 'رانچ * 7 دن',
              th: 'รถเมล์ * 7 วัน'
            },
            img: '/img/activity/pk/p_zq1.png',
            id: Math.random()
          }
        ]
      }
    ]
    let pkGifts = [
      {
        title:{en:'NO2',tr:'İlk 2',ar:'NO2', ru: 'Топ-2', uz: 'Top-2', id: 'NO2', pt: 'NO2', fa: 'اولین', ur: 'اولین', th: 'ที่ 2'},
        list: [
          {
            name:{en:'Medal * 7days<br/>(score>400K)', tr:'Madalya (7Gün)<br/>(400K Üstü)', ar:'Medal * 7days<br/>(score>400K)', ru:'Медаль * 7 дней<br/>(счёт > 400K)', id:'Medali * 7 hari<br/>(skor>400K)', pt:'Medalha * 7 dias<br/>(pontuação>400K)', uz:'Medal * 7 kun<br/>(ball>400K)', fa:'مدال * 7 روز<br/>(امتیاز > 400K)', ur:'میڈل * 7 دن<br/>(اسکور>400K)', th:'เหรียญ * 7 วัน<br/>(คะแนน>400K)'},
            img: '/img/activity/pk/pp_xz2.png',
            id: Math.random()
          },
          {
            name:{en:'Headwear * 7days', tr:'Çerçeve (7Gün)', ar:'Headwear * 7days', ru:'Головной убор * 7 дней', id:'Penutup Kepala * 7 hari', pt:'Chapéus * 7 dias', uz:'Bosh kiyimlar * 7 kun', fa:'سرپوش * ۷ روز', ur:'ہیڈویئر * 7 دن', th:'หมวก * 7 วัน'},
            img: '/img/activity/pk/p_t2.png',
            id: Math.random()
          },
          {
            name:{en:'Mount * 7days', tr:' Araç (7Gün)', ar:'Mount * 7days', ru:'Транспорт * 7 дней', id:'Kendaraan * 7 hari', pt:'Veículo * 7 dias', uz:'Transport * 7 kun', fa:'موتور * ۷ روز', ur:'رانچ * 7 دن', th:'รถเมล์ * 7 วัน'},
            img: '/img/activity/pk/p_zq2.png',
            id: Math.random()
          }
        ],
        list2: [
          {
            name:{en:'Marquis * 7days', tr:'Vip 3 (7Gün)', ar:'Marquis * 7days', ru:'Маркс * 7 дней', id:'Mengambil * 7 hari', pt:'Levando * 7 dias', uz:'7 kun davom etadi', fa:'مصرف * ۷ روز', ur:'* 7 دن لے رہے ہیں۔', th:'ใช้เวลา * 7 วัน'},
            img: ' https://img.chatie.live/app/noble/vipicon/vip_lv3.png',
            id: Math.random()
          },
        ]
      },
      {
        title:{en:'NO3',tr:'İlk 3',ar:'NO3', ru: 'Топ-3', uz: 'Top-3', id: 'NO3', pt: 'NO3', fa: 'اولین', ur: 'اولین', th: 'ที่ 3'},
        list: [
          {
            name:{en:'Medal * 7days<br/>(score>250K)', tr:'Madalya (7Gün)<br/> (250K Üstü)', ar:'Medal * 7days<br/>(score>250K)', ru:'Медаль * 7 дней<br/>(счёт > 250K)', id:'Medali * 7 hari<br/>(skor>250K)', pt:'Medalha * 7 dias<br/>(pontuação>250K)', uz:'Medal * 7 kun<br/>(ball>250K)', fa:'مدال * 7 روز<br/>(امتیاز > 250K)', ur:'میڈل * 7 دن<br/>(اسکور>250K)', th:'เหรียญ * 7 วัน<br/>(คะแนน>250K)'},
            img: '/img/activity/pk/pp_xz3.png',
            id: Math.random()
          },
          {
            name:{en:'Headwear * 7days', tr:'Çerçeve (7Gün)', ar:'Headwear * 7days', ru:'Головной убор * 7 дней', id:'Penutup Kepala * 7 hari', pt:'Chapéus * 7 dias', uz:'Bosh kiyimlar * 7 kun', fa:'سرپوش * ۷ روز', ur:'ہیڈویئر * 7 دن', th:'หมวก * 7 วัน'},
            img: '/img/activity/pk/p_t3.png',
            id: Math.random()
          }
        ],
        list2: [
          {
            name:{en:'Mount * 7days', tr:'Araç (7 Gün)', ar:'Mount * 7days', ru:'Транспорт * 7 дней', id:'Kendaraan * 7 hari', pt:'Veículo * 7 dias', uz:'Transport * 7 kun', fa:'موتور * ۷ روز', ur:'رانچ * 7 دن', th:'รถเมล์ * 7 วัน'},
            img: '/img/activity/pk/p_zq3.png',
            id: Math.random()
          },

        ]
      }
    ]
    // booster
    let boosterTopGifts = [
      {
        title:{en:'NO1',tr:'İlk 1',ar:'NO1', ru: 'Топ-1', uz: 'Top-1', id: 'NO1', pt: 'NO1', fa: 'اولین', ur: 'اولین', th: 'ที่ 1'},
        list: [
          {
            name:{en:'Medal * 7days<br/>(score>500K)', tr:'Madalya (7 Gün)<br/>(500K Üstü)', ar:'Medal * 7days<br/>(score>500K)', ru:'Медаль * 7 дней<br/>(счёт > 500K)', id:'Medali * 7 hari<br/>(skor>500K)', pt:'Medalha * 7 dias<br/>(pontuação>500K)', uz:'Medal * 7 kun<br/>(ball>500K)', fa:'مدال * 7 روز<br/>(امتیاز > 500K)', ur:'میڈل * 7 دن<br/>(اسکور>500K)', th:'เหรียญ * 7 วัน<br/>(คะแนน>500K)'},
            desc: 'won',
            img: '/img/activity/pk/bb_xz1.png',
            id: Math.random()
          }
        ],
        list2: [
          {
            name:{en:'Banner * 7days', tr:'Banner (7Gün)', ar:'Banner * 7days', ru:'Баннер * 7 дней', id:'Spanduk * 7 hari', pt:'Banner * 7 dias', uz:'Banner * 7 kun', fa:'بنر * 7 روز', ur:'بنر * 7 دن', th:'แบรนด์ * 7 วัน'},
            img: '/img/activity/pk/banner.png',
            id: Math.random()
          },
          {
            name:{en:'Duke * 7days', tr:'Vip 4 (7Gün)', ar:'Duke * 7days', ru:'Герцог * 7 дней', id:'Mengambil * 7 hari', pt:'Levando * 7 dias', uz:'7 kun davom etadi', fa:'مصرف * ۷ روز', ur:'* 7 دن لے رہے ہیں۔', th:'ใช้เวลา * 7 วัน'},
            img: '/img/activity/pk/duke.png',
            id: Math.random()
          },
          {
            name:{en:'Headwear * 7days', tr:'Çerçeve (7Gün)', ar:'Headwear * 7days', ru:'Головной убор * 7 дней', id:'Penutup Kepala * 7 hari', pt:'Chapéus * 7 dias', uz:'Bosh kiyimlar * 7 kun', fa:'سرپوش * ۷ روز', ur:'ہیڈویئر * 7 دن', th:'หมวก * 7 วัน'},
            img: '/img/activity/pk/b_t1.png',
            id: Math.random()
          }
        ],
        list3: [
          {
            name:{en:'Mount * 7days', tr:'Araç (7Gün)', ar:'Mount * 7days', ru:'Транспорт * 7 дней', id:'Kendaraan * 7 hari', pt:'Veículo * 7 dias', uz:'Transport * 7 kun', fa:'موتور * ۷ روز', ur:'رانچ * 7 دن', th:'รถเมล์ * 7 วัน'},
            img: '/img/activity/pk/b_zq1.png',
            id: Math.random()
          },

        ]
      }
    ]
    let boosterGifts = [
      {
        title:{en:'NO2',tr:'İlk 2',ar:'NO2', ru: 'Топ-2', uz: 'Top-2', id: 'NO2', pt: 'NO2', fa: 'اولین', ur: 'اولین', th: 'ที่ 2'},
        list: [
          {
            name:{en:'Medal * 7days<br/>(score>400K)', tr:'Madalya (7Gün)<br/>(400K Üstü)', ar:'Medal * 7days<br/>(score>400K)', ru:'Медаль * 7 дней<br/>(счёт > 400K)', id:'Medali * 7 hari<br/>(skor>400K)', pt:'Medalha * 7 dias<br/>(pontuação>400K)', uz:'Medal * 7 kun<br/>(ball>400K)', fa:'مدال * 7 روز<br/>(امتیاز > 400K)', ur:'میڈل * 7 دن<br/>(اسکور>400K)', th:'เหรียญ * 7 วัน<br/>(คะแนน>400K)'},
            img: '/img/activity/pk/bb_xz2.png',
            id: Math.random()
          },
          {
            name:{en:'Headwear * 7days', tr:'Çerçeve (7Gün)', ar:'Headwear * 7days', ru:'Головной убор * 7 дней', id:'Penutup Kepala * 7 hari', pt:'Chapéus * 7 dias', uz:'Bosh kiyimlar * 7 kun', fa:'سرپوش * ۷ روز', ur:'ہیڈویئر * 7 دن', th:'หมวก * 7 วัน'},
            img: '/img/activity/pk/b_t2.png',
            id: Math.random()
          },
          {
            name:{en:'Mount * 7days', tr:'Araç (7Gün)', ar:'Mount * 7days', ru:'Транспорт * 7 дней', id:'Kendaraan * 7 hari', pt:'Veículo * 7 dias', uz:'Transport * 7 kun', fa:'موتور * ۷ روز', ur:'رانچ * 7 دن', th:'รถเมล์ * 7 วัน'},
            img: '/img/activity/pk/b_zq2.png',
            id: Math.random()
          }
        ],
        list2: [
          {
            name:{en:'Marquis * 7days', tr:'Vip 3 (7Gün)', ar:'Marquis * 7days', ru:'Маркс * 7 дней', id:'Mengambil * 7 hari', pt:'Levando * 7 dias', uz:'7 kun davom etadi', fa:'مصرف * ۷ روز', ur:'* 7 دن لے رہے ہیں۔', th:'ใช้เวลา * 7 วัน'},
            img: '/img/activity/pk/marquis.png',
            id: Math.random()
          },

        ]
      },
      {
        title:{en:'NO3',tr:'İlk 3',ar:'NO3', ru: 'Топ-3', uz: 'Top-3', id: 'NO3', pt: 'NO3', fa: 'اولین', ur: 'اولین', th: 'ที่ 3'},
        list: [
          {
            name:{en:'Medal * 7days<br/>(score>250K)', tr:'Madalya (7Gün)<br/>(250K Üstü)', ar:'Medal * 7days<br/>(score>250K)', ru:'Медаль * 7 дней<br/>(счёт > 250K)', id:'Medali * 7 hari<br/>(skor>250K)', pt:'Medalha * 7 dias<br/>(pontuação>250K)', uz:'Medal * 7 kun<br/>(ball>250K)', fa:'مدال * 7 روز<br/>(امتیاز > 250K)', ur:'میڈل * 7 دن<br/>(اسکور>250K)', th:'เหรียญ * 7 วัน<br/>(คะแนน>250K)'},
            img: '/img/activity/pk/bb_xz3.png',
            id: Math.random()
          },
          {
            name:{en:'Headwear * 7days', tr:'Çerçeve (7Gün)', ar:'Headwear * 7days', ru:'Головной убор * 7 дней', id:'Penutup Kepala * 7 hari', pt:'Chapéus * 7 dias', uz:'Bosh kiyimlar * 7 kun', fa:'سرپوش * ۷ روز', ur:'ہیڈویئر * 7 دن', th:'หมวก * 7 วัน'},
            img: '/img/activity/pk/b_t3.png',
            id: Math.random()
          }
        ],
        list2: [
          {
            name:{en:'Mount * 7days', tr:' Araç (7Gün)', ar:'Mount * 7days', ru:'Транспорт * 7 дней', id:'Kendaraan * 7 hari', pt:'Veículo * 7 dias', uz:'Transport * 7 kun', fa:'موتور * ۷ روز', ur:'رانچ * 7 دن', th:'รถเมล์ * 7 วัน'},
            img: '/img/activity/pk/b_zq3.png',
            id: Math.random()
          },

        ]
      }
    ]
    // room
    let roomTopGifts = [
      {
        title:{en:'NO1',tr:'İlk 1',ar:'NO1', ru: 'Топ-1', uz: 'Top-1', id: 'NO1', pt: 'NO1', fa: 'اولین', ur: 'اولین', th: 'ที่ 1'},
        list: [
          {
            name:{en:'Medal * 7days', tr:'Madalya (7Gün)', ar:'Medal * 7days', ru:'Медаль * 7 дней', id:'Medali * 7 hari', pt:'Medalha * 7 dias', uz:'Medal * 7 kun', fa:'مدال * 7 روز', ur:'میڈل * 7 دن', th:'เหรียญ * 7 วัน'},
            desc: 'won',
            img: '/img/activity/pk/c1.png',
            id: Math.random()
          }
        ],
        list2: [],
        list3: []
      }
    ]
    let roomGifts = [
      {
        title:{en:'NO2',tr:'İlk 2',ar:'NO2', ru: 'Топ-2', uz: 'Top-2', id: 'NO2', pt: 'NO2', fa: 'اولین', ur: 'اولین', th: 'ที่ 2'},
        list: [
          {
            name:{en:'Medal * 7days', tr:'Madalya (7Gün)', ar:'Medal * 7days', ru:'Медаль * 7 дней', id:'Medali * 7 hari', pt:'Medalha * 7 dias', uz:'Medal * 7 kun', fa:'مدال * 7 روز', ur:'میڈل * 7 دن', th:'เหรียญ * 7 วัน'},
            img: '/img/activity/pk/c2.png',
            id: Math.random()
          }
        ],
        list2: []
      },
      {
        title:{en:'NO3',tr:'İlk 3',ar:'NO3', ru: 'Топ-3', uz: 'Top-3', id: 'NO3', pt: 'NO3', fa: 'اولین', ur: 'اولین', th: 'ที่ 3'},
        list: [
          {
            name:{en:'Medal * 7days', tr:'Madalya (7Gün)', ar:'Medal * 7days', ru:'Медаль * 7 дней', id:'Medali * 7 hari', pt:'Medalha * 7 dias', uz:'Medal * 7 kun', fa:'مدال * 7 روز', ur:'میڈل * 7 دن', th:'เหรียญ * 7 วัน'},
            img: '/img/activity/pk/c3.png',
            id: Math.random()
          }
        ],
        list2: []
      }
    ]

    let diffRewars = () => {
      if (this.state.tabShow == '0') {
        return pkGifts
      } else if (this.state.tabShow == '1') {
        return boosterGifts
      } else {
        return roomGifts
      }
    }
    let diffTopRewars = () => {
      if (this.state.tabShow == '0') {
        return pkTopGifts
      } else if (this.state.tabShow == '1') {
        return boosterTopGifts
      } else {
        return roomTopGifts
      }
    }

    return (
      <div className="container">
        <div className="rule-btn" onClick={this.changeRule.bind(this, { state: true, value: '0' })}>
          {lang.rule}
        </div>
        {/* <div className="history-btn" onClick={this.changeRule.bind(this, { state: true, value: '1' })}>
          {lang.HonorList}
        </div> */}
        <RuleReminder
          lang={this.state.lang}
          language={this.state.language}
          showRule={this.state.showRule}
          changeRule={this.changeRule.bind(this)}
          historyList={historyList}
          ruleOrHis={this.state.ruleOrHis}
        />

        {/* head */}
        <div className="header">
          <div className="title"></div>
          <div className="avatar">
            <div className="avatar-border"></div>
            <div
              className="user1"
              onClick={jumpToUser.bind(
                this,
                lastKingRank && lastKingRank.length > 0 && lastKingRank[0] && lastKingRank[0].uid
              )}
            ></div>
            <div
              className="user2"
              onClick={jumpToUser.bind(
                this,
                lastSupporterRank && lastSupporterRank.length > 0 && lastSupporterRank[0] && lastSupporterRank[0].uid
              )}
            ></div>
            <div className="avatar-user">
              <div className="user-one">
                <img
                  src={
                    (lastKingRank && lastKingRank.length > 0 && lastKingRank[0] && lastKingRank[0].avatarurl) ||
                    (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')
                  }
                />
              </div>
              <div className="user-two">
                <img
                  src={
                    (lastSupporterRank &&
                      lastSupporterRank.length > 0 &&
                      lastSupporterRank[0] &&
                      lastSupporterRank[0].avatarurl) ||
                    (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')
                  }
                />
              </div>
            </div>
            <div className="avatar-name">
              <div className="left">
                {(lastKingRank && lastKingRank.length > 0 && lastKingRank[0] && lastKingRank[0].nickname) || ''}
              </div>
              <div className="right">
                {(lastSupporterRank &&
                  lastSupporterRank.length > 0 &&
                  lastSupporterRank[0] &&
                  lastSupporterRank[0].nickname) ||
                  ''}
              </div>
            </div>
          </div>
        </div>
        {/* head */}

        {/* tabbar */}
        <div className="tabbar">
          <div
            className={`pk-king ${this.state.tabShow == '0' ? 'active' : ''}`}
            onClick={this.changeNav.bind(this, '0')}
          >
            <p>{lang.pkking}</p>
          </div>
          <div
            className={`supporter ${this.state.tabShow == '1' ? 'active' : ''}`}
            onClick={this.changeNav.bind(this, '1')}
          >
            <p>{lang.supporter}</p>
          </div>
          <div className={`room ${this.state.tabShow == '2' ? 'active' : ''}`} onClick={this.changeNav.bind(this, '2')}>
            <p>{lang.room}</p>
          </div>
          <div className="select" style={{ left: this.leftData() }}></div>
        </div>
        {/* tabbar */}

        {/* PK and supporter */}
        <div style={{ display: `${this.state.tabShow != '2' ? 'block' : 'none'}` }}>
          <RankLastWeek
            kingSupporterData={this.state.tabShow == '0' ? lastKingRank.slice() : lastSupporterRank.slice()}
            kingSupporterMyData={this.state.tabShow == '0' ? lastKingMyRank : lastSupporterMyRank}
            lang={this.state.lang}
            language={this.state.language}
          />
          <RankThisWeek
            kingSupporterData={this.state.tabShow == '0' ? thisKingRank.slice() : thisSupporterRank.slice()}
            kingSupporterMyData={this.state.tabShow == '0' ? thisKingMyRank : thisSupporterMyRank}
            lang={this.state.lang}
            language={this.state.language}
            remaintime={remaintime}
          />
        </div>

        {/* 房间 */}
        <div style={{ display: `${this.state.tabShow == '2' ? 'block' : 'none'}` }}>
          <RoomLastWeek lastRoomRank={lastRoomRank} lang={this.state.lang} language={this.state.language} />
          <RoomThisWeek
            thisRoomRank={thisRoomRank}
            thisRoomMyRank={thisRoomMyRank}
            lang={this.state.lang}
            language={this.state.language}
            remainTime={remaintime}
          />
        </div>

        {/* 奖励 */}
        <PkReward
          lang={this.state.lang}
          language={this.state.language}
          supporterGiftsList={diffRewars()}
          topGiftsList={diffTopRewars()}
          tabShow={this.state.tabShow}
          changeRule={this.changeRule.bind(this)}
        />

        <div className="service" onClick={jumpToUser.bind(this, 977239)}>
          {lang.service}
        </div>

        <div className="srcs" style={{ display: 'none' }}>
          <img src="/img/activity/pk/rule.png" alt="" />
          <img src="/img/activity/national/x.png" alt="" />
          <img src="/img/activity/pk/tbg.png" alt="" />
          <img src="/img/activity/pk/gift_b.png" alt="" />
          <img src="/img/activity/pk/honor_b.png" alt="" />
          <img src="/img/activity/pk/tie_b.png" alt="" />
          <img src="/img/activity/pk/time_b.png" alt="" />
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/index.js